import { MenuItem } from '@components/dropdown';
import { useConfiguration, useCurrentUser } from '@components/router/session-context';
import { hasLevel } from 'shared/auth';
import { useIntl } from 'shared/intl/use-intl';
import { RootUserMenu } from '@components/root-page-layout';

interface Props {
  class?: string;
}

export function UserMenu({ class: className = '' }: Props) {
  const intl = useIntl();
  const user = useCurrentUser();
  const configuration = useConfiguration();

  if (!user) {
    return null;
  }

  return (
    <div class={`flex items-center font-normal ${className}`}>
      <RootUserMenu
        renderMenu={() => (
          <>
            <MenuItem href="/account">{intl('Account')}</MenuItem>
            {hasLevel(user, 'admin') && (
              <MenuItem href="/admin/people">{intl('Manage Site')}</MenuItem>
            )}
            <MenuItem href="/courses">{intl('My Courses')}</MenuItem>
            <MenuItem
              href={
                hasLevel(user, 'guide')
                  ? 'https://support.ruzuku.com/collection/741-guide-help'
                  : configuration.tenant.supportUrl ||
                    'https://support.ruzuku.com/collection/746-student-help'
              }
            >
              {intl('Support')}
            </MenuItem>
            <MenuItem href="/logout">{intl('Logout')}</MenuItem>
          </>
        )}
      />
    </div>
  );
}
